import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'

export type TransactionType =
  | 'Deposit'
  | 'Charge'
  | 'Bonus'
  | 'AdminAdd'
  | 'AdminRemove'
  | 'Refund'

export type TransactionProps = ModelProps<Transaction>

export class Transaction extends Model<Transaction> {
  id = Id.none

  @observable accessor amount = 0
  @observable accessor billingMethodId = Id.none
  @observable accessor dateCreated = unixEpoch()
  @observable accessor transactionType: TransactionType = 'Charge'
  @observable accessor jobId = Id.none
  @observable accessor jobName: string | null = null
  @observable accessor receiptUrl: string | null = null
}
